// ゴミ箱からの動画復元（復元先フォルダ選択モーダルの状態管理）
import { computed, ref } from 'vue';
import { useFolderTree } from './useFolderTree';

export const useTrashRestore = ({ folders }) => {
  const trashRestoreFolderId = ref('');
  const trashRestoreFolderMissing = ref(false);
  const trashRestoreAction = ref('');

  const {
    topLevelFolders: trashRestoreTopLevelFolders,
    getChildren: trashRestoreGetChildren,
    isCollapsed: trashRestoreIsCollapsed,
    toggleFolder: trashRestoreToggleFolder,
    expandAncestorsOf: trashRestoreExpandAncestorsOf,
    scrollSelectedFolderIntoView: trashRestoreScrollSelectedFolderIntoView,
  } = useFolderTree(folders, trashRestoreFolderId, {
    persist: false,
    initialCollapse: 'collapseAll',
    scrollContainerSelector: '.folder-picker-tree',
  });

  const trashRestoreSelectFolder = (folderId) => {
    trashRestoreFolderId.value = folderId;
  };

  const trashRestoreSelectRoot = () => {
    trashRestoreFolderId.value = 'root';
  };

  // 'root' 選択中かどうか。hidden input `folder_id`/`to_root` の disabled 出し分けにも使う
  const trashRestoreIsRootSelected = computed(
    () => trashRestoreFolderId.value === 'root'
  );

  const openTrashRestoreModal = ({ videoId, folderId, folderMissing }) => {
    const modalEl = document.getElementById('trashRestoreModal');
    if (!modalEl) {
      return;
    }

    trashRestoreAction.value = modalEl.dataset.actionTemplate.replace(
      '__VIDEO_ID__',
      String(videoId)
    );
    trashRestoreFolderMissing.value = !!folderMissing;
    if (folderId == null) {
      // TOP直下の動画は「TOP」を事前選択する
      trashRestoreFolderId.value = 'root';
    } else if (folderMissing) {
      // 元フォルダが消失している場合は未選択のままにし、選択を強制する
      trashRestoreFolderId.value = '';
    } else {
      trashRestoreFolderId.value = String(folderId);
    }

    if (trashRestoreFolderId.value && trashRestoreFolderId.value !== 'root') {
      trashRestoreExpandAncestorsOf(trashRestoreFolderId.value);
    }

    if (window.jQuery) {
      window.jQuery('#trashRestoreModal').modal('show');
    }
  };

  const scrollToSelectedTrashRestoreFolder = () => {
    if (!trashRestoreFolderId.value) {
      // 選択中のフォルダが無い（元フォルダ消失）場合、前回開いたときのスクロール位置が
      // 残ったままになる（Bootstrapモーダルは閉じてもDOMが破棄されないため）。
      // ツリー先頭に戻す。
      const container = document.querySelector('#trashRestoreModal .folder-picker-tree');
      if (container) {
        container.scrollTop = 0;
      }
      return;
    }
    trashRestoreScrollSelectedFolderIntoView(trashRestoreFolderId.value);
  };

  return {
    trashRestoreFolderId,
    trashRestoreFolderMissing,
    trashRestoreAction,
    trashRestoreTopLevelFolders,
    trashRestoreGetChildren,
    trashRestoreIsCollapsed,
    trashRestoreToggleFolder,
    trashRestoreSelectFolder,
    trashRestoreSelectRoot,
    trashRestoreIsRootSelected,
    openTrashRestoreModal,
    scrollToSelectedTrashRestoreFolder,
  };
};
